import { render } from 'react-dom';
import reportWebVitals from './reportWebVitals';
import App from './App';
import { logger } from 'utils/logger';

import './legacy/bootstrap/css/bootstrap.css';
import './common/css/Common.scss';
import { injectToPrototype } from 'common/Js/prototypeUtils';

logger.info('Starting Cynet360');

if (!process.env.REACT_APP_VERSION) {
  throw new Error('REACT_APP_VERSION is not set');
}

// @ts-ignore
window.cynet = {
  version: process.env.REACT_APP_VERSION
};

injectToPrototype();

render(<App />, document.getElementById('app'));

reportWebVitals();
